import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';
import { makeQueryString } from '../../util';

export type V_DetailAsAdmin = {
  '@id': string;
  '@type': 'Organisation';
  id: string;
  name: string;
  licencePrefix: string;
  logo: string | null;
  licenceCount: number;
  claimedLicenceCount: number;
};

export type V_ListAsAdmin = {
  '@id': string;
  '@type': 'Organisation';
  id: string;
  name: string;
  createdAt: string;
  licenceCount: number;
  claimedLicenceCount: number;
};

export type W = {
  name: string;
  licencePrefix: string;
  logo: string | null;
};

export function useReadCollection(
  queryParams?: { name?: string },
  options?: ReadConfig,
) {
  return useApiRead<HydraCollection<V_ListAsAdmin>>(
    `/organisations${makeQueryString(queryParams)}`,
    options,
  );
}

export function useReadItem(id: string, options?: ReadConfig) {
  return useApiRead<V_DetailAsAdmin>(`/organisations/${id}`, options);
}
